__turbopack_context__.v({
  "buttonMinimal": "wfHRsq_buttonMinimal",
});
